import { useEffect, useRef } from 'react';
import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import { SnackbarProvider, useSnackbar } from 'notistack';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import useAuth from 'src/hooks/useAuth';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import AppInit from './components/AppInit';
import WhatsAppDisconnectedAlert from './components/WhatsAppDisconnectedAlert';
import BackendDownAlert from './components/BackendDownAlert';

function BlockedAccountNotifier() {
  const { enqueueSnackbar } = useSnackbar();
  const { logout } = useAuth();
  const logoutRef = useRef(logout);

  useEffect(() => {
    logoutRef.current = logout;
  });

  useEffect(() => {
    const handle = (event) => {
      // O backend distingue os motivos do 401 ('Conta bloqueada', 'Token errado',
      // 'Token não enviado!!', ...). Só o bloqueio real merece a mensagem de
      // suporte — os demais são sessão expirada/inválida.
      const reason = event?.detail?.reason || '';
      const isBlocked = reason.toLowerCase().includes('bloqueada');
      enqueueSnackbar(
        isBlocked
          ? 'Sua conta está bloqueada. Entre em contato com o suporte.'
          : 'Sua sessão expirou. Faça login novamente.',
        {
          variant: isBlocked ? 'error' : 'warning',
          autoHideDuration: 6000,
        }
      );
      logoutRef.current();
    };
    window.addEventListener('auth:unauthorized', handle);
    return () => window.removeEventListener('auth:unauthorized', handle);
  }, [enqueueSnackbar]);

  return null;
}

function App() {
  const content = useRoutes(router);
  const auth = useAuth();

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider
          maxSnack={6}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
        >
          <CssBaseline />
          <BlockedAccountNotifier />
          <BackendDownAlert />
          <WhatsAppDisconnectedAlert />
          {auth.isInitialized ? content : <AppInit />}
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
